import axiosV1 from "@/plugins/axios/configV1";

export default {
    addCustomer(...payload) {
        return axiosV1.post("users/customers", ...payload);
    },
    getCustomers(params) {
        return axiosV1.get(`users/customers`, { params });
    },
    getCustomer(id = null) {
        return axiosV1.get(`users/customers/edit/${id}`);
    },
    getCustomerFull(id, params) {
        return axiosV1.get(`users/customers/view/${id}`, { params });
    },
    updateCustomer(id = null, user = {}) {
        let formData = new FormData();
        for (const key in user) {
            formData.append(key, user[key] ? user[key] : "");
        }
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";
        return axiosV1.post(`users/customers/update/${id}`, formData);
    },
    deleteCustomer(id = null) {
        return axiosV1.post(`users/customers/delete/${id}`);
    },
    deleteCustomers(ids = null) {
        return axiosV1.post(`users/customers/bulk/delete`, ids);
    },
    recoverCustomer(id = null) {
        return axiosV1.post(`users/customers/revert/${id}`);
    },
    recoverCustomers(ids = null) {
        return axiosV1.post(`users/customers/bulk/revert`, ids);
    },
    acceptDelete(id = null) {
        return axiosV1.post(`users/customers/pending-delete/approve/${id}`);
    },
    acceptDeleteAll(ids = null) {
        return axiosV1.post(`users/customers/pending-delete/bulk/approve`, ids);
    },
    rejectDelete(id = null, reason = "") {
        return axiosV1.post(`users/customers/pending-delete/decline/${id}`, {
            reason,
        });
    },
    exportExcel(params = {}) {
        return axiosV1.get(`users/customers/export`, { params });
    },
    sendEmail(ids = null) {
        return axiosV1.post(`users/customers/email-blast`, ids);
    },
};
